import { distinctUntilChanged, filter, map, OperatorFunction, pipe } from 'rxjs';

import { isFn } from '@contact/upgrade';

import { EntityState } from './entity';

/**
 * select element in store with given project properties
 * @param project is function selector or string properties
 */
export function select<T, K extends keyof T, R extends T[K]>(project: ((state: T) => R) | K): OperatorFunction<T, R> {
  if (isFn(project)) {
    // otherwise use map
    return pipe(map<T, R>(project), distinctUntilChanged<R>());
  } else {
    // if project is properties use pluck operator
    return pipe(
      // select properties in json
      map<T, R>(value => value[project] as R),
      distinctUntilChanged<R>()
    );
  }
}

/**
 * select all entities in store
 * @return array entity
 */
export function selectAll<T>(): OperatorFunction<EntityState<T>, T[]> {
  return map<EntityState<T>, T[]>(state => state.ids.map(key => state.entities[key]));
}

/**
 * select ids entity in store
 * @return array string
 */
export function selectIds<T>(): OperatorFunction<EntityState<T>, string[]> {
  return map(state => state.ids);
}

/**
 * select entity with given id
 * @param id is key of map
 */
export function selectById<T>(id: string): OperatorFunction<EntityState<T>, T> {
  return pipe(
    map<EntityState<T>, T>(state => state.entities[id]),
    filter<T>(state => !!state),
    distinctUntilChanged<T>()
  );
}
